import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { SalesChannel } from 'src/app/assabil-kernel/models/entities/control-tables/sales-channel';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { SalesChannelRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/sales-channel-request';



@Component({
  selector: 'sales-channel-list',
  templateUrl: './sales-channel-list.component.html',
  styleUrls: ['./sales-channel-list.component.scss']
})
export class SalesChannelListComponent extends BasePage2<SalesChannel> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  salesChannels: SalesChannel[] = [];
  // ---------------------------------------------------
  
  //----------------------------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName  = 'salesChannel';
  }
  //----------------------------------------------------------------------


//----------------------------------------------------------------------
  listFields = [
      { prop: 'salesChannelCode', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' },
  ]
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  getRows(): SalesChannel[] {
      return this.salesChannels;
  }
//----------------------------------------------------------------------

  

//----------------------------------------------------------------------
new(){
    let entity : SalesChannel = new SalesChannel();
    entity.inserted = true;
    entity.edit = true;
    this.salesChannels.push(entity);
    this.salesChannels = [...this.salesChannels];
}
//----------------------------------------------------------------------

       

//----------------------------------------------------------------------
saveRow(salesChannel: SalesChannel): Promise<SalesChannel> {
    let request  : SalesChannelRequest = new SalesChannelRequest(this.controlService.getUserInfo());
    request.salesChannel = salesChannel;
      return this.controlService.save(this.entityName, request);
  }
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;
    this.controlService.getList(this.entityName, request).then(result => {
        this.salesChannels = result;
    })
  }
//----------------------------------------------------------------------

}


